export enum TypeChangementDate {
	MOIS,
	SEMAINE
}
